module.exports = __webpack_public_path__ + "media/components/assets/img/icons/marker-from-0888ff6e539de0d43aa99134a346d452.svg";